import { View } from "./Dashboard.view";

export const Container = () => {
  return <View />;
};
